@if (filteredFunding.length > 0) {
<div>
	<div class="title">
		{{ Loc(LocalizedTextIds.Funding) }}
	</div>
	<table>
		<tr>
			<th>{{ Loc(LocalizedTextIds.CompanyDetailsFundingRound) }}</th>
			<th class="currencycolumn">
				{{ Loc(LocalizedTextIds.CompanyDetailsAmount) }}
			</th>
			<!-- Don't include currency in header, since there can be a mix of currencies -->
			<th>{{ Loc(LocalizedTextIds.CompanyDetailsDateRaised) }}</th>
			<th>{{ Loc(LocalizedTextIds.CompanyDetailsFundingParty) }}</th>
			@if(showConfidentialStatus) {
			<th class="confidentialcolumn">
				{{ Loc(LocalizedTextIds.CompanyDetailsConfidential) }}
			</th>
			}
		</tr>
		@for(item of filteredFunding; track item.modelId) {
		<tr>
			<td>{{ LocDbValue(item.fundingRound) }}</td>
			<td class="currencycolumn">
				<!-- Note that this will be substituted for N/A on the server-side for J&J Deals -->
				@if(IsNumberOrNumberString(item.raised)) {
				<span
					>{{
						item.raised
							| currency
								: item.raisedCurrency
								: 'symbol-narrow'
								: '1.0-0'
					}}
					{{ item.raisedCurrency }}</span
				>
				} @else {
				{{ item.raised }}
				}
			</td>
			<td>{{ item.dateRaised | date : 'mediumDate' : 'GMT' }}</td>
			<td>{{ item.fundingParty }}</td>
			@if(showConfidentialStatus){
			<td class="confidentialcolumn">
				<div>
					{{
						Loc(
							item.isConfidential
								? LocalizedTextIds.Yes
								: LocalizedTextIds.No
						)
					}}
				</div>
			</td>
			}
		</tr>
		}
	</table>
</div>
}
